import axiosClient from './axiosService';

const BASE_URL = '/studies';

export const getAllStudies = () =>
    axiosClient.get(BASE_URL);

export const getStudyById = (id) =>
    axiosClient.get(`${BASE_URL}/${id}`);

export const createStudy = (study) =>
    axiosClient.post(BASE_URL, study);

export const updateStudy = (id, study) =>
    axiosClient.put(`${BASE_URL}/${id}`, study);

export const deleteStudy = (id) =>
    axiosClient.delete(`${BASE_URL}/${id}`);

export const getStudiesByLevel = (level) =>
    axiosClient.get(`${BASE_URL}/search/by-level`, {
        params: { level },
    });

export const getStudiesByUniversity = (universityName) =>
    axiosClient.get(`${BASE_URL}/search/by-university`, {
        params: { universityName },
    });

export const getStudiesByCountry = (country) =>
    axiosClient.get(`${BASE_URL}/search/by-country`, {
        params: { country },
    });

export const getStudiesByStudentId = (studentId) =>
    axiosClient.get(`${BASE_URL}/search/by-student`, {
        params: { studentId },
    });

export const getTotalStudyCount = () =>
    axiosClient.get(`${BASE_URL}/count`);

export const getStudyCountByStudentId = (studentId) =>
    axiosClient.get(`${BASE_URL}/count/by-student`, {
        params: { studentId },
    });
